import { Pipe, PipeTransform } from '@angular/core';
import { CodeAndName } from '@lx/shared/types';

@Pipe({
  standalone: true,
  name: 'lxJuniorCampsSchoolDescription',
})
export class JuniorCampsSchoolDescriptionPipe implements PipeTransform {
  transform(languages: CodeAndName[]): string {
    if (!languages?.length) {
      return '';
    }

    let schoolDescription = '';
    languages.forEach(({ name }, index) => {
      schoolDescription += name;
      if (index < languages.length - 2) {
        schoolDescription += ', ';
      } else if (index === languages.length - 2) {
        schoolDescription += ' and ';
      }
    });
    schoolDescription += languages.length === 1 ? ' course' : ' courses';
    return schoolDescription;
  }
}
